import { useEffect, useState } from 'react'
import { useCaseSchemaStatus } from '@/features/schema/hooks/useCaseSchemaStatus'

const remindedCases = new Set<string>()

function claimReminder(caseId: string): boolean {
  if (remindedCases.has(caseId)) return false
  const key = `spectre:documents:schema-reminder:v1:${caseId}`
  remindedCases.add(caseId)
  try {
    if (window.localStorage.getItem(key)) return false
    window.localStorage.setItem(key, 'seen')
  } catch {
    // Keep the reminder once per tab when browser storage is unavailable.
  }
  return true
}

interface SchemaUploadReminderOptions {
  caseId: string
  hasDocuments: boolean
  uploadDialogOpen: boolean
}

/** Also covers imports and returning to documents after the first upload. */
export function useSchemaUploadReminder({
  caseId,
  hasDocuments,
  uploadDialogOpen,
}: SchemaUploadReminderOptions) {
  const schema = useCaseSchemaStatus(caseId)
  const [reminderCaseId, setReminderCaseId] = useState<string | null>(null)
  const eligible = hasDocuments && schema.needsSchema && !uploadDialogOpen
  useEffect(() => {
    if (!eligible) {
      setReminderCaseId(null)
      return
    }
    if (claimReminder(caseId)) setReminderCaseId(caseId)
  }, [caseId, eligible])
  return {
    open: eligible && reminderCaseId === caseId,
    dismiss: () => setReminderCaseId(null),
  }
}
